import PropTypes from 'prop-types';
import React, { memo } from 'react';
import { convertNumberWithThousandCommas } from '../../../utils/convertValues';

/**
 * @description Render memoized added product cart modal template
 * @param {Object} props
 * @returns {JSX.Element} Memoized added product cart modal template
 */
export const AddedProduct = memo(function MemoizedAddedProduct(props) {
  const {
    item: { name = null, image_url = '#', options = null, sale_price = 0, quantity = 1 }
  } = props;

  return (
    <div>
      {typeof name === 'string' && name.length > 0 ? <span className="block text-base md:hidden">{name}</span> : null}

      <div className="flex items-center">
        <div className="mr-4">
          {typeof image_url === 'string' && image_url.length > 0 ? (
            <img className="h-24 w-24" src={image_url} alt="" loading="lazy" />
          ) : null}
        </div>

        <div className="grow">
          {typeof name === 'string' && name.length > 0 ? (
            <p className="hidden text-2xl font-normal md:block">{name}</p>
          ) : null}

          <div className="flex flex-col gap-x-4 text-gray-500   md:flex-row">
            <div className="flex flex-1 flex-col justify-between text-sm font-normal md:flex-row md:text-base">
              {options && Array.isArray(options) && options.length > 0
                ? options.map(({ name = null, value = null }, index) => (
                    <span key={index}>
                      {name}: {value}
                    </span>
                  ))
                : null}

              <span className="hidden justify-self-end md:block">Qty: {quantity}</span>

              {typeof sale_price === 'number' ? (
                <span className="hidden text-black md:block">
                  ${convertNumberWithThousandCommas(sale_price.toLocaleString(undefined, { minimumFractionDigits: 2 }))}
                </span>
              ) : null}
            </div>
            <div className="flex w-full justify-between text-sm text-black md:hidden md:text-base">
              <span className="justify-self-end">Qty: {quantity}</span>

              {typeof sale_price === 'number' ? (
                <span>${sale_price.toLocaleString(undefined, { minimumFractionDigits: 2 })}</span>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
});

AddedProduct.propTypes = {
  item: PropTypes.shape({
    name: PropTypes.string,
    image_url: PropTypes.string,
    options: PropTypes.arrayOf(
      PropTypes.shape({
        name: PropTypes.string,
        value: PropTypes.string
      })
    ),
    sale_price: PropTypes.number
  })
};
